// Central navigation source -- header + mobile menu read from here.
export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/our-group", label: "Our Group" },
  { to: "/founder", label: "Founder" },
  { to: "/ventures", label: "Our Brands" },
  { to: "/blog", label: "Blog" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact Us" },
];

// Secondary links kept live for continuity/SEO but intentionally out of
// the primary header nav -- surfaced only in the footer.
export const FOOTER_SECONDARY_LINKS = [
  { to: "/vision-values", label: "Vision & Values" },
];

export const FOOTER_LEGAL_LINKS = [
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/terms", label: "Terms of Use" },
];
